<template>
  <div>
    <div class="tw-text-gray-800 tw-flex">
      <money-format :value="event.amount" :locale="locale" subunits-value />
      &nbsp;{{ title }}
    </div>
    <div class="tw-text-gray-500 tw-text-xs">
      {{ event.label }}
    </div>
    <div v-if="event.amountRefunded" class="tw-flex tw-text-gray-500 tw-text-xs tw-items-center">
      <money-format :value="event.amountRefunded" :locale="locale" subunits-value />&nbsp;Refunded
      <span class="tw-mx-1">&#x2022;</span>
      <money-format :value="event.amount - event.amountRefunded" :locale="locale" subunits-value />&nbsp;Remaining
    </div>
    <div class="tw-flex tw-items-center tw-gap-2">
      <base-button class="tw-mt-1" type="text" size="xs" @click="$emit('refundCharge', event)" v-if="showRefund === true">Refund</base-button>
      <base-button class="tw-mt-1" v-if="isGenerating === true" disabled type="text" size="xs">
        <template #icon>
          <base-spinner :size="16" current class="tw-mr-2" />
        </template>
        Generating Receipt...
      </base-button>
      <base-button v-if="isGenerating === false && localCharge" class="tw-mt-1" type="text" size="xs" @click="generateInvoicePdf()">
        Generate Receipt
      </base-button>
    </div>
  </div>
</template>

<script>
import MoneyFormat from "vue-money-format";
import BaseSpinner from "@/components/base/BaseSpinner";
import { startCase } from "lodash";
import { mapGetters } from "vuex";

export default {
  components: {
    MoneyFormat,
    BaseSpinner,
  },
  props: {
    businessId: String,
    userId: String,
    event: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isGenerating: false,
      intervalId: null,
      charge: { ...this.event },
      localCharge: { ...this.event },
    };
  },
  computed: {
    ...mapGetters("role", ["isLocationFiltered"]),
    locale() {
      return window.navigator.language;
    },
    title() {
      return startCase(this.event.type);
    },
    showRefund() {
      return this.event.amount > this.event.amountRefunded && this.event.type.toLowerCase() !== "charge failed" && !this.isLocationFiltered;
    },
  },
  watch: {
    charge: {
      handler(newCharge) {
        this.localCharge = { ...newCharge };
      },
      deep: true,
    },
  },
  methods: {
    async generateInvoicePdf() {
      this.isSendingGenerateInvoicePdf = true;
      this.isGenerating = true;

      try {
        let response = await this.$axios.post(`/businesses/${this.businessId}/users/${this.userId}/charges/${this.charge.eventId}/invoice/pdf`);
        if (response.status === 200) {
          this.isGenerating = false; // Stop generating after successful response
          this.EventBus.$emit("GLOBAL_NOTIFY", { title: "PDF Queued", message: "This may take a minute or two to add the to the Member Documents tab." });
        }
      } catch (error) {
        console.error("Error generating invoice PDF:", error);
        this.EventBus.$emit("GLOBAL_ERROR", { title: "Error", message: "Failed to generate receipt." });
      } finally {
        this.isGenerating = false;
      }
    },
  },
};
</script>
